import { TRESPONSE_DAILY_OPL_CAPACITIES } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';
import { TGrouppedHeader, TTableCellTree, TTableOptions, TTableRowNode } from '../../table.type';
import _ from 'lodash';
import moment from 'moment';

function _getDates(dateRange: TRESPONSE_DAILY_OPL_CAPACITIES['dateRange']) {
  const days = moment.duration(moment(dateRange.to, 'YYYY-MM-DD').diff(moment(dateRange.from, 'YYYY-MM-DD'))).days();

  return _.range(0, days + 1).map((dayCount) =>
    moment(dateRange.from, 'YYYY-MM-DD').add(dayCount, 'days').format('YYYY-MM-DD'),
  );
}

function _getHeaderConfig(
  totalCapacitiesByDate: TRESPONSE_DAILY_OPL_CAPACITIES['totalCapacitiesByDate'],
  dates: string[],
) {
  const lineCell: TTableOptions['headerConfig'] = [
    {
      type: 'TEXT_LIST_CELL',
      widthInPx: 100,
      text: ['LINE NO.'],
      borderRight: true,
    },
  ];

  const totalCapacityCell: TTableOptions['headerConfig'] = [
    {
      type: 'TEXT_CELL',
      text: 'TOTAL CAPACITY',
    },
  ];

  const capacityCells: TTableOptions['headerConfig'] = dates.map((date, ind) => {
    const totalCapacityByDate = totalCapacitiesByDate[date]; //TODO[Ramya]: check this
    const totalCapacity = totalCapacityByDate
      ? `${totalCapacityByDate.allocatedCapacity}/${totalCapacityByDate.installedCapacity}`
      : '';
    return {
      type: 'TEXT_LIST_CELL',
      textAlign: 'center',
      text: totalCapacity ? [ind === 0 ? 'TOTAL CAPACITY' : '', totalCapacity] : [],
      borderRight: true,
    };
  });

  return lineCell
    .concat(capacityCells)
    .concat(totalCapacityCell)
    .map((x) => {
      return { ...x };
    });
}

function _getGrouppedHeaderConfig(dates: string[]) {
  const dateCells: TGrouppedHeader['cells'] = dates.map((date) => {
    const formattedDate = moment(date, 'YYYY-MM-DD').format('MMM D');
    return {
      type: 'TEXT_CELL',
      text: formattedDate,
      span: 1,
    };
  });

  const emptyCell: TGrouppedHeader['cells'] = [
    {
      type: 'EMPTY_CELL',
      span: 1,
    },
  ];

  const config: TGrouppedHeader = {
    type: 'GROUPPED_HEADER',
    cells: emptyCell.concat(dateCells).concat(emptyCell),
  };

  return config;
}

function _getTableRowCells(item: TRESPONSE_DAILY_OPL_CAPACITIES['capacitiesByLine'][number]) {
  const sortedCapacitiesByDate = _.sortBy(item.capacitiesByDate, 'date');
  const sortedCapacitiesCells: TTableCellTree[] = sortedCapacitiesByDate.map((cpty, ind) => {
    return {
      type: 'TEXT_LIST_CELL',
      text: cpty.oplCapacities.map((x) => {
        return `${x.userOPLId}(${x.allocatedCapacity}/${cpty.installedCapacity})`;
      }),
      background: cpty.stripColor,
      fullHeight: true,
      borderRight: ind === sortedCapacitiesByDate.length - 1,
    };
  });

  const lineCell: TTableCellTree[] = [
    {
      type: 'TEXT_LIST_CELL',
      text: [item.lineDisplayName, item.floorDisplayName],
    },
  ];

  const totalCapacityCell: TTableCellTree[] = [
    {
      type: 'TEXT_CELL',
      text: `${item.allocatedCapacity}/${item.installedCapacity}`,
    },
  ];

  return lineCell.concat(sortedCapacitiesCells).concat(totalCapacityCell);
}

export const OPL_DAILY_VIEW_MODEL = {
  createModel(dailyOPLCapacities?: TRESPONSE_DAILY_OPL_CAPACITIES) {
    if (dailyOPLCapacities) {
      const dates = _getDates(dailyOPLCapacities.dateRange);
      return ModifiersZTableModel.createTableModel(
        dailyOPLCapacities.capacitiesByLine,
        {
          headerConfig: _getHeaderConfig(dailyOPLCapacities.totalCapacitiesByDate, dates),
          grouppedHeaderConfig: _getGrouppedHeaderConfig(dates),
        },
        (item): TTableRowNode<TRESPONSE_DAILY_OPL_CAPACITIES['capacitiesByLine'][number]> => {
          return {
            type: 'ROW',
            rowItem: item,
            cells: _getTableRowCells(item),
          };
        },
      );
    } else {
      return ModifiersZTableModel.createTableModel(
        [] as TRESPONSE_DAILY_OPL_CAPACITIES['capacitiesByLine'],
        { headerConfig: [] },
        (item): TTableRowNode<TRESPONSE_DAILY_OPL_CAPACITIES['capacitiesByLine'][number]> => {
          return {
            type: 'ROW',
            rowItem: item,
            cells: [],
          };
        },
      );
    }
  },
};
